import React, { useEffect, useState } from 'react'
import './player-leaderboards-container.styles.scss';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { switchPlayerMenu } from '../side-menu.component';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import LeaderboardPage from '@/pages/leaderboard/leaderboard.page';
import { useSelector } from 'react-redux';
import { sortElementsNoThe } from '@/utils/sortElements';

const PlayerLeaderboardsContainer = ({
  gameData,
  gameElements,
  playerData,
  playerList
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [leaderboards, setLeaderboards] = useState(null);
  const [visibleLeaderboard, setVisibleLeaderboard] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pageTitle = document.getElementById('page-title');
    if (pageTitle) {
      pageTitle.innerText = 'Leaderboards'
    }
    switchPlayerMenu('leaderboards-btn');
  }, []);

  useEffect(() => {
    if (!gameElements || !gameData) return;
    const ldbdList = sortElementsNoThe(
      Object.values(gameElements)
        .filter(e => e.type === 'leaderboard')
    );
    setLeaderboards(ldbdList);
    navigate(
      location.pathname.includes('/preview/player/')
      ? `/preview/player/${gameData.path}/leaderboards/${ldbdList[0].path}`
      : `/play/${gameData.path}/leaderboards/${ldbdList[0].path}`
    );
  }, [gameElements, gameData])

  useEffect(() => {
    if (!visibleLeaderboard) return;

  }, [visibleLeaderboard])

  return (
    <div className='player-leaderboards-container'>
      <div className='g-card player-leaderboards'>
        <div className='player-title'>
          <ImageContainer
            src='/images/icons/leaderboard.png'
            alt='rewards icon'
            className='player-title-icon' />
          Leaderboards
        </div>
        <hr />
        <div className={`leaderboard-grid ${screenSize}`}>
          <div className='leaderboard-list'>
            {
              (leaderboards) &&
              leaderboards
                .map(l => (
                  <button
                    key={l.id}
                    className={`g-button med-btn ${location.pathname.includes(l.path)
                        ? 'primary'
                        : ''
                      }`}
                    onClick={() => navigate(
                      location.pathname.includes('/preview/player/')
                      ? `/preview/player/${gameData.path}/leaderboards/${l.path}`
                      :  `/play/${gameData.path}/leaderboards/${l.path}`)}>
                    {l.name}
                  </button>
                ))
            }
          </div>
          <div className='leaderboard-view'>
            <Routes>
              <Route path='/:livePath' element={
                <LeaderboardPage
                  playerView={true}
                  playerData={playerData} />
                // playerList={playerList}
                // playerGameData={gameData} />
              }></Route>
            </Routes>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlayerLeaderboardsContainer